<script setup lang="ts">
import { useHead } from '@unhead/vue';

import 'vue-sonner/style.css'; // vue-sonner v2 requires this import

import { whenever } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

import Icon from '@/components/Icon.vue';
import { Toaster } from '@/components/ui/sonner';
import { useSessionStore } from '@/store/session';

const { t } = useI18n();

const { fetchHistory, historyIsFirstLoading, sessionId } = useSessionStore();

whenever(sessionId, () => fetchHistory(), { immediate: true });

useHead({
  // Direct ref
  title: t('app.title'),
  meta: [
    // Computed getter (recommended for derived values)
    { name: 'description', content: () => t('app.description') },
  ],
});
</script>

<template>
  <div class="flex h-full grow flex-col">
    <div
      class="bg-background pointer-events-none fixed inset-0 z-[999] flex h-full items-center justify-center transition-all duration-300"
      :class="{
        'opacity-100': historyIsFirstLoading,
        'scale-125 opacity-0': !historyIsFirstLoading,
      }"
      id="loading"
      @transitionend="($event.target as HTMLElement).remove()"
    >
      <Icon icon="loader" size="extra-large" class="text-white/40" />
    </div>

    <router-view />
  </div>

  <Toaster />
</template>
